import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { TFacilityStatus, TFacilityStatusInput } from "redux/reducers/models/facility";
import { TLeagueRegistrationInputTypes } from "../league/registration/inputs";

const apiVersion = "2024-04";
const adminType = "facility-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/facility/status";

export type TGetFacilityStatus = {
  date?: string;
  month?: string;
};

export type TPostFacilityStatus = {
  /** YYYY-MM-DD */
  date: string;
  input_data: Array<{ status_input_id: number; value: string }>;
};

// GET Facility Statuses
export async function GetFacilityStatus(params: TGetFacilityStatus, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<TFacilityStatus[]>(baseUrl, params, useGlobalLoader, token);
}

// POST Facility Statuses
export async function PostFacilityStatus(params: TPostFacilityStatus, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/status"), params, useGlobalLoader);
}

// GET Facility Status Inputs
export async function GetFacilityStatusInputs(params: any, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<TFacilityStatusInput[]>(baseUrl + "/input", params, useGlobalLoader, token);
}

interface IPostFacilityStatusInput {
  label: string;
  help_text?: string;
  type: string;
}

// POST Facility Status Input
export async function PostFacilityStatusInput(params: IPostFacilityStatusInput, useGlobalLoader: boolean) {
  return await APIPost<TFacilityStatusInput>(baseUrl + "/input", params, useGlobalLoader);
}

export type TPutStatusInput = {
  id: number;
  label?: string;
  help_text?: string;
  type?: TLeagueRegistrationInputTypes;
  values?: string[];
  required?: boolean;
};

export type TPutStatusInputPosition = {
  id: number;
  row: number;
  column: number;
};

export async function PutStatusInput(params: TPutStatusInput, useGlobalLoader = true) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/status/input"), params, useGlobalLoader);
}

export async function PutStatusInputPositions(params: { inputs: TPutStatusInputPosition[] }, useGlobalLoader = true) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/status/input/position"), params, useGlobalLoader);
}

export async function DeleteStatusInput(params: any, useGlobalLoader = true) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/facility/status/input"), params, useGlobalLoader);
}
